<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5AxIqt/tc-custom/9780765387073.jpg?1737746322476" alt="This image is the cover for the book The Forlorn Hope"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Forlorn Hope
      </h1>
      <p class="bookDescription body article font2">
        <b>A band of mercenaries must fight their way across a hostile planet after they’re sold out to the enemy in this classic military science fiction odyssey.</b><br/><br/>They had fought long and hard, and damn near won in spite of everything. But now the men who hired them are going to sell them to the enemy . . . and so begins a novel of adventure in which a band of Star Mercenaries is driven across the face of a planet by enemies bent on their destruction. With only the guns in their hands, this tiny band must battle ships, artillery, treachery, and the most powerful tank in the universe . . .<br/><br/><b>Praise for <i>The Forlorn Hope</i></b><br/><br/>“Vigorous and compelling. . . . A book that any Hammer’s Slammers fan will enjoy. . . . A page-turner, fast-paced and hard to put down.” —<i>Reactor</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Drake
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29cbf7eb